import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from '@mui/material';

const PlayerOverview = ({ playerDataOverview, playerDataRanks }) => {
    const data = [
        { label: "Current Elo", value: playerDataOverview.currentElo, rank: playerDataRanks.currentEloRank },
        { label: "Win Percent", value: playerDataOverview.winPercent, rank: playerDataRanks.winPercentRank },
        { label: "Win Count", value: playerDataOverview.winCount, rank: playerDataRanks.winCountRank },
        { label: "Loss Count", value: playerDataOverview.lossCount, rank: playerDataRanks.lossCountRank },
        { label: "Max Elo", value: playerDataOverview.maxElo, rank: playerDataRanks.highestEloRank },
        { label: "Race Count", value: playerDataOverview.raceCount, rank: playerDataRanks.raceCountRank },
        { label: "APN", value: playerDataOverview.apn, rank: playerDataRanks.apnRank },
        { label: "Relative Win Count", value: playerDataOverview.relativeWinCount, rank: playerDataRanks.relativeWinCountRank },
        { label: "Relative Loss Count", value: playerDataOverview.relativeLossCount, rank: playerDataRanks.relativeLossCountRank },
        { label: "Relative Win Percent", value: playerDataOverview.relativeWinPercent, rank: playerDataRanks.relativeWinPercentRank }
    ];

    return (
        <Box sx={{ maxWidth: '90vw', display: 'flex', alignItems: 'center', justifyContent: 'center', width: "400px"}}>
      <Paper sx={{ maxWidth: '90vw', mb: 2, overflow: 'hidden', width: "400px"}}>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align='left' sx={{ backgroundColor: '#4A4A4A', color: 'white' }}>Stat</TableCell>
                        <TableCell align='center' sx={{ backgroundColor: '#4A4A4A', color: 'white' }}>Value</TableCell>
                        <TableCell align='center' sx={{ backgroundColor: '#4A4A4A', color: 'white' }}>Rank</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white' }}>
                            <TableCell align='left'>{row.label}</TableCell>
                            <TableCell align='center'>{row.value}</TableCell>                            
                            <TableCell align='center'>{row.rank}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        </Paper>
        </Box>
    );
};

export default PlayerOverview;
